module.exports = __webpack_public_path__ + "img/product_106.2c8b4e0.webp";